import React, { useEffect, useRef, useState } from 'react'
import { Box } from '@mui/material'
import icons from '~/assets/icons'

const LocalSVGIcon = (props: { color?: string, name: string, size: number }) => {
  const { color, name, size } = props
  const { loading, SvgIcon } = useDynamicSvgImport(name)

  if (loading) {
    return <Box sx={{ width: size, height: size }} />
  }

  if (!SvgIcon) return null
  return <SvgIcon width={size} height={size} fill={color} stroke={color} />
}

function useDynamicSvgImport(iconName: string) {
  const importedIconRef = useRef<React.FC<React.SVGProps<SVGElement>>>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<unknown>()

  useEffect(() => {
    const path = icons[iconName as keyof typeof icons]

    const parts = path.split('/')
    const [family, file] = parts

    if (family !== 'local') {
      return
    }

    const [fileName, fileExtension] = file.split('.')
    setLoading(true)
    const importSvgIcon = async (): Promise<void> => {
      try {
        importedIconRef.current = (
          await import(`../assets/icons/local/${fileName}.${fileExtension}?react`)
        ).default
      } catch (err) {
        setError(err)
        console.error(err)
      } finally {
        setLoading(false)
      }
    }

    importSvgIcon()
  }, [iconName])

  return { error, loading, SvgIcon: importedIconRef.current }
}

export default LocalSVGIcon